import { DataUtilLocalStorage } from '../../../data/util/LocalStorage';

export const GLOBAL_SEARCH_STORAGE_GROUP = 'globalSearch';

const RECENT_SEARCHES_KEY = 'recentSearches';
const MAX_RECENT_SEARCHES = 8;

export namespace GlobalSearchStorage {
    export function getRecentSearches(): string[] {
        const rawValue = DataUtilLocalStorage._GetItem<string>(GLOBAL_SEARCH_STORAGE_GROUP, RECENT_SEARCHES_KEY, '[]');

        if (!rawValue) {
            return [];
        }

        try {
            const parsed = JSON.parse(rawValue);

            if (!Array.isArray(parsed)) {
                return [];
            }

            return parsed.filter(item => typeof item === 'string' && item.trim().length > 0);
        }

        catch {
            return [];
        }
    }

    export function saveRecentSearch(searchTerm: string) {
        const cleanTerm = searchTerm.trim();

        if (!cleanTerm) {
            return;
        }

        const currentValues = getRecentSearches().filter(item => item.toLowerCase() !== cleanTerm.toLowerCase());
        const nextValues = [cleanTerm,
            ...currentValues].slice(0, MAX_RECENT_SEARCHES);

        DataUtilLocalStorage._SetItem(GLOBAL_SEARCH_STORAGE_GROUP, RECENT_SEARCHES_KEY, JSON.stringify(nextValues));
    }

    export function clearRecentSearches() {
        DataUtilLocalStorage._RemoveItem(GLOBAL_SEARCH_STORAGE_GROUP, RECENT_SEARCHES_KEY);
    }
}